var _style, _g, _path, _polygon, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 216",
    style: {
      enableBackground: "new 0 0 250 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st6{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M188.3,111.2C188.3,111.2,188.3,111.1,188.3,111.2c-0.6-1.1-1.1-2-1.5-2.8l-56.4-97.7L129,8.5l-3.9-6.7 L89.8,62.9l26.9,45.7l5.6-9.6l2.9-5l22.6,39.1c5.3,11.1,1.1,24.6-9.5,30.8c-11.3,6.5-25.8,2.7-32.3-8.6l-1.9-3.2l0,0l-3.2-5.5 l-25.6,44.3c9.6,10.3,22.1,17.5,36.1,20.6c5,1.1,10.1,1.7,15.2,1.7c12.1,0,24.1-3.2,34.8-9.3c7.1-4.1,13.2-9.2,18.4-15.4 c0.8-0.9,1.6-1.9,2.3-2.9C198.1,164.1,200.6,134.9,188.3,111.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.9,134.6c0.1,0.2,0.2,0.4,0.3,0.5L84.9,119l0,0L93.9,134.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "84.9,119 71.3,95.3 71.2,95.3 84.9,119 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M247.8,214.3l-47.7-82.6c3,19.7-1.9,40.4-14.2,56.7c-1.2,1.5-2.4,3-3.7,4.5l12.3,21.4H247.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "71.2,95.3 71.2,95.3 44.6,141.4 44.6,141.4 41.7,146.4 2.5,214.3 55.7,214.3 69,191.4 71.7,186.7 97.9,141.5  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.0504e300.svg";
export { ForwardRef as ReactComponent };